import React, { useEffect, useMemo, useState } from "react";
import "./wpDashboard.scss";
import { MenuItem, TextField, Paper } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {
  guestType,
  docType,
  Italy_Country_Code,
} from "../../Constants/Constants";
import state_List from "../../Constants/state_list.json";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import CustomLoaderBoxy from "../../components/CustomLoader/CustomLoaderBoxy";
import AllServices from "../../Services/AllServices";
import countries_List from "../../Constants/country_list.json";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { ImageBaseURLServer } from "../../Constants/Constants";
import "dayjs/locale/it";
import WpConfirmationTable from "../WpConfirmationTable/WpConfirmationTable";

const imageBaseURL = ImageBaseURLServer;

const WPDashboard = () => {
  const { state } = useLocation();
  const [query, setQuery] = useState("");
  const [queryState, setQueryState] = useState("");
  const [queryDocIssuing, setQueryDocIssuing] = useState("");
  const [queryDocType, setQueryDocType] = useState("");
  const [open, setOpen] = useState(false);
  const [openState, setOpenState] = useState(false);
  const [openDocIssing, setOpenDocIssing] = useState(false);
  const [openDoc, setOpenDoc] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [stayDays, setStayDays] = useState();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    famType: "",
    placeOfBirth: "",
    docIssuingPlace: "",
    docType: "",
    docNumber: "",
    provinceCode: "",
    citizen: "",
    arrivingDate: "",
    firstName: "",
    lastName: "",
    sex: "",
    birthState: "",
    dob: "",
  });
  const [error, setError] = useState({
    famType: false,
    placeOfBirth: false,
    docIssuingPlace: false,
    docType: false,
    docNumber: false,
    citizen: false,
  });
  const [submitClicked, setSubmitClicked] = useState(false);
  const [btnName, setBtnName] = useState("Conferma");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [dataStore, setDataStore] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  const mergeCountriesAndState = [...countries_List, ...state_List];

  const filtered = useMemo(() => {
    if (!query) return [];
    return countries_List
      .filter((c) => c.country.toLowerCase().startsWith(query.toLowerCase()))
      .slice(0, 20);
  }, [query]);

  const filteredState = useMemo(() => {
    if (!queryState) return [];
    return state_List
      .filter((c) =>
        c.country.toLowerCase().startsWith(queryState.toLowerCase()),
      )
      .slice(0, 20);
  }, [queryState]);

  const filteredDocIssuing = useMemo(() => {
    if (!queryDocIssuing) return [];
    return mergeCountriesAndState
      .filter((c) =>
        c.country.toLowerCase().startsWith(queryDocIssuing.toLowerCase()),
      )
      .slice(0, 20);
  }, [queryDocIssuing]);

  // const getFilteredCountiesForDocIssuing = useMemo(() => {
  //   if (!queryDocIssuing) return [];
  //   return countries_List
  //     .filter((c) =>
  //       c.country.toLowerCase().startsWith(queryDocIssuing.toLowerCase())
  //     )
  //     .slice(0, 20);
  // }, [queryDocIssuing]);

  const getFilteredCountriesForBirth = useMemo(() => {
    if (!queryState) return [];
    return mergeCountriesAndState
      .filter((c) =>
        c.country.toLowerCase().startsWith(queryState.toLowerCase()),
      )
      .slice(0, 20);
  }, [queryState]);

  const finalFiltered = getFilteredCountriesForBirth;

  const filteredDoc = useMemo(() => {
    if (!queryDocType) return [];
    return docType
      .filter((doc) =>
        doc.name.toLowerCase().startsWith(queryDocType.toLowerCase()),
      )
      .slice(0, 20);
  }, [queryDocType]);

  // format Data di Arrivo to DD/MM/YYYY
  const arrivingdate = data?.booking?.[0]?.Arriving_DateTime
    ? dayjs(data.booking[0].Arriving_DateTime).subtract(1, "day")
    : null;

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((prev) => {
      let updated = { ...prev, [name]: value };

      if (name === "citizen") {
        // updated.placeOfBirth = "";
        updated.provinceCode = "";
        // updated.docIssuingPlace = "";
        setQuery(value);
        setOpen(true);
        // setQueryState("");
        // setQueryDocIssuing("");
      } else if (name === "placeOfBirth") {
        setQueryState(value);
        setOpenState(true);
      } else if (name === "docIssuingPlace") {
        setQueryDocIssuing(value);
        setOpenDocIssing(true);
      }

      return updated;
    });

    // Handle validation error
    if (submitClicked) {
      setError((prev) => ({
        ...prev,
        [name]: value === "",
      }));
    }
  };

  const handleChangeDocType = (event) => {
    const { name, value } = event.target;

    setQueryDocType(value);
    setOpenDoc(true);

    if (submitClicked) {
      setError((prev) => ({
        ...prev,
        [name]: value === "",
      }));
    }
  };

  const handleSubmit = async () => {
    setSubmitClicked(true);

    const newErrors = {
      famType: form.famType === "",
      placeOfBirth: form.placeOfBirth === "",
      docIssuingPlace: form.docIssuingPlace === "",
      docType: form.docType === "",
      docNumber: form.docNumber === "",
      citizen: form.citizen === "",
    };

    setError(newErrors);
    const hasError = Object.values(newErrors).some(Boolean);
    // if single guest
    if (form.famType === guestType[0].ID) {
      if (!hasError) {
        let dataObj = {
          refNumber: state.refNumber,
          famType: form.famType,
          docType: form.docType,
          placeOfBirth: form.placeOfBirth,
          docIssuingPlace: form.docIssuingPlace,
          NumberDoc: form.docNumber,
          stayDays: stayDays,
          provinceCode: form.provinceCode,
          arrivingDate: form.arrivingDate,
          firstName: form.firstName,
          lastName: form.lastName,
          sex: form.sex,
          birthState: form.birthState,
          dob: form.dob,
          citizen: form.citizen,
        };
        let dataPacket = {
          mainGuest: dataObj,
          childGuest: null,
        };

        try {
          setDataStore(dataPacket);
          setOpenModal(true);
        } catch (error) {
          toast.error(error);
        } finally {
          setLoading(false);
        }
      }
    } else {
      if (!hasError) {
        navigate("/adminuser/webportal/step_2", {
          state: {
            refNumber: state.refNumber,
            famType: form.famType,
            docType: form.docType,
            placeOfBirth: form.placeOfBirth,
            docIssuingPlace: form.docIssuingPlace,
            docNumber: form.docNumber,
            stayDays: stayDays,
            provinceCode: form.provinceCode,
            birthState: form.birthState,
            citizen: form.citizen,
          },
        });
      }
    }
  };

  const handleViewPDF = async (date) => {
    // const date = "2026-01-04";
    // const today = new Date().toISOString().split("T")[0];

    // setLoading(true);

    try {
      const response = await AllServices.getRecipt({ date });

      const soapXML = response.data.message;

      // Extract Base64 from <PDF> tag
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(soapXML, "text/xml");

      const pdfNode = xmlDoc.getElementsByTagName("PDF")[0];

      if (!pdfNode) {
        toast.error("PDF not found in response");
        return;
      }

      const pdfBase64 = pdfNode.textContent;

      // Convert Base64 to Blob
      const byteCharacters = atob(pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });

      // Create URL and open in new tab
      const pdfUrl = URL.createObjectURL(blob);

      window.open(pdfUrl, "_blank");
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const fetchDetails = async () => {
    try {
      setLoading(true);
      var response = await AllServices.gellAllCustomerDetailsById(
        state?.refNumber,
      );

      if (!response) {
        toast.error("Something went rong!");
        return;
      }

      let checkChildrenArray = response.data.message.childrens;
      if (!checkChildrenArray || checkChildrenArray.length === 0) {
        setBtnName("Invia");
        setForm((prev) => ({
          ...prev,
          famType: guestType[0].ID,
        }));
        setBtnDisabled(true);
      }

      setData({ ...response.data.message });
      setForm((prev) => ({
        ...prev,
        // citizen: response.data.message.Country,
        arrivingDate:
          response.data.message.booking[0].Arriving_DateTime.split("T")[0],
        firstName: response.data.message.Fname,
        lastName: response.data.message.Lname,
        dob: response.data.message.DOB.split("T")[0],
        sex: response.data.message.Gender,
        // birthState: response.data.message.Country,
      }));
      const booking = response.data.message.booking[0];
      const arriving = dayjs(booking.Arriving_DateTime).startOf("day");
      const departure = dayjs(booking.Depature_DateTime).startOf("day");
      const days = departure.diff(arriving, "day");
      setStayDays(days);
    } catch (error) {
      toast.error(error?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  const formRender = () => {
    const exists = countries_List.some(
      (country) => country.code === form.placeOfBirth,
    );
    if (exists) {
      setForm((prev) => ({
        ...prev,
        birthState: form.placeOfBirth,
        // provinceCode: "",
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        birthState: Italy_Country_Code,
      }));
    }
  };

  const onClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    formRender();
  }, [form.placeOfBirth]);

  useEffect(() => {
    fetchDetails();
  }, []);

  return (
    <div className="wp-dashboard-containor">
      {loading && (
        <div className="loader-overlay">
          <CustomLoaderBoxy />
        </div>
      )}
      {openModal && (
        <div className="loader-overlay">
          <WpConfirmationTable data={dataStore} onClose={onClose} />
        </div>
      )}
      <div className="wp-dashboard-wrapper">
        <div className="top-containor">
          <h2>Inserimento On-Line </h2>
          <div className="reference-image">
            <div className="doc-wrapper">
              {(() => {
                const guestFiles = Array.isArray(data?.files)
                  ? data.files.filter((file) =>
                      file.Fieldname.startsWith("guests[0][documents]"),
                    )
                  : [];
                return guestFiles.length > 0 ? (
                  guestFiles.map((item, index) => (
                    <div key={index} className="doc-wrapper">
                      {item.FileName.endsWith(".pdf") ? (
                        <a
                          href={`${imageBaseURL}${item.FileName}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="pdf-icon-containor">
                            <PictureAsPdfOutlinedIcon className="pdf-icon" />
                            <span>View PDF</span>
                          </div>
                        </a>
                      ) : (
                        <a
                          href={`${imageBaseURL}${item.FileName}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${imageBaseURL}${item.FileName}`}
                            alt="Main Guest"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                              borderRadius: "4px",
                              transition: "transform 0.3s",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.transform = "scale(1.2)")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          />
                        </a>
                      )}
                    </div>
                  ))
                ) : (
                  <span>No Documnet</span>
                );
              })()}
            </div>
          </div>
        </div>

        <div className="infinite-line"></div>

        <div className="familiy-info-line">
          <TextField
            className="textField"
            id="outlined-basic"
            name="famType"
            select
            label="Tipo"
            variant="outlined"
            value={form.famType}
            onChange={handleChange}
            slotProps={{
              select: {
                MenuProps: {
                  disablePortal: true,
                },
              },
            }}
            disabled={btnDisabled}
            error={submitClicked && error.famType}
            helperText={
              submitClicked && error.famType ? "This field is required" : ""
            }
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: !form.famType ? "blue" : undefined,
                borderWidth: !form.famType ? "1px" : undefined,
              },

              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: !form.famType ? "blue" : undefined,
              },

              "& .MuiInputLabel-root": {
                color: !form.famType ? "black" : undefined,
              },
            }}
          >
            {data?.childrens?.length > 0 ? (
              guestType.slice(1, 3).map((option) => (
                <MenuItem
                  key={option.ID}
                  value={option.ID}
                  onClick={() => {
                    setBtnName(
                      option.ID === guestType[0].ID ? "Invia" : "Conferma",
                    );
                  }}
                >
                  {option.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem key={guestType[0].ID} value={guestType[0].ID}>
                {guestType[0].name}
              </MenuItem>
            )}
          </TextField>

          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
            <DatePicker
              label="Data di Arrivo"
              maxDate={dayjs()}
              format="DD/MM/YYYY"
              value={arrivingdate}
              disabled
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  className="textField"
                  id="outlined-basic"
                />
              )}
            />
          </LocalizationProvider>

          <TextField
            className="textField"
            variant="outlined"
            type="number"
            required
            label="Permanenza"
            value={stayDays}
            disabled
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
        </div>

        <div className="location-info-line">
          <div style={{ position: "relative" }}>
            <TextField
              className="textField"
              name="citizen"
              label="Cittadinanza"
              value={query}
              onChange={handleChange}
              onBlur={() => {
                const exactMatch = filtered.some(
                  (item) => item.country === query,
                );
                if (!exactMatch) {
                  setQuery("");
                  setForm((prev) => ({ ...prev, citizen: "" }));
                }
                setTimeout(() => setOpen(false), 200);
              }}
              error={submitClicked && error.citizen}
              helperText={
                submitClicked && error.citizen ? "Cittadinanza is required" : ""
              }
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: !form.citizen ? "blue" : undefined,
                  borderWidth: !form.citizen ? "1px" : undefined,
                },

                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: !form.citizen ? "blue" : undefined,
                },

                "& .MuiInputLabel-root": {
                  color: !form.citizen ? "black" : undefined,
                },
              }}
            />

            {open && filtered.length > 0 && (
              <Paper
                sx={{
                  position: "absolute",
                  width: "100%",
                  zIndex: 10,
                  maxHeight: 250,
                  overflowY: "auto",
                }}
              >
                {filtered.map((item, index) => (
                  <MenuItem
                    key={index}
                    onMouseDown={() => {
                      setQuery(item.country);
                      setForm((prev) => ({
                        ...prev,
                        citizen: item.code,
                      }));
                      setOpen(false);
                    }}
                  >
                    {item.country}
                  </MenuItem>
                ))}
              </Paper>
            )}
          </div>

          <div style={{ position: "relative" }}>
            <TextField
              className="textField"
              name="placeOfBirth"
              label="Luogo di Nascita"
              value={queryState}
              onChange={handleChange}
              // disabled={form.citizen === ""}
              onBlur={() => {
                const exactMatch = finalFiltered.some(
                  (item) => item.country === queryState,
                );
                if (!exactMatch) {
                  setQueryState("");
                  setForm((prev) => ({ ...prev, placeOfBirth: "" }));
                }
                setTimeout(() => setOpen(false), 200);
              }}
              error={submitClicked && error.placeOfBirth}
              helperText={
                submitClicked && error.placeOfBirth
                  ? "Luogo di Nascita is required"
                  : ""
              }
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: !form.placeOfBirth ? "blue" : undefined,
                  borderWidth: !form.placeOfBirth ? "1px" : undefined,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: !form.placeOfBirth ? "blue" : undefined,
                },
                "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: !form.placeOfBirth ? "blue" : undefined,
                  },
                // "& .MuiInputLabel-root": {
                //   color: !form.citizen ? "blue" : undefined,
                // },
                "& .Mui-disabled": {
                  cursor: "not-allowed",
                },
              }}
            />

            {openState && finalFiltered.length > 0 && (
              <Paper
                sx={{
                  position: "absolute",
                  width: "100%",
                  zIndex: 10,
                  maxHeight: 250,
                  overflowY: "auto",
                }}
              >
                {finalFiltered.map((item, index) => (
                  <MenuItem
                    key={index}
                    onMouseDown={() => {
                      setQueryState(item.country);
                      setForm((prev) => ({
                        ...prev,
                        placeOfBirth: item.code,
                        provinceCode: item.province,
                      }));
                      setOpenState(false);
                    }}
                  >
                    {item.country}
                  </MenuItem>
                ))}
              </Paper>
            )}
          </div>
        </div>

        <div className="personal-info-line">
          <div className="upper-line">
            <TextField
              className="textField"
              id="outlined-basic"
              type="text"
              label="Cognome"
              variant="outlined"
              value={data.Fname}
              disabled
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            />
            <TextField
              className="textField"
              id="outlined-basic"
              type="text"
              label="Nome"
              variant="outlined"
              value={data.Lname}
              disabled
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            />
          </div>
          <div className="down-line">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Data di Nascita"
                maxDate={dayjs()}
                format="YYYY-MM-DD"
                value={data.DOB}
                disabled
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    className="textField"
                    id="outlined-basic"
                  />
                )}
              />
            </LocalizationProvider>

            <TextField
              className="textField"
              id="outlined-basic"
              label="Sesso"
              required
              variant="outlined"
              value={data.Gender}
              disabled
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            />
          </div>
        </div>

        <div className="doc-info-line">
          {/* <TextField
            className="textField"
            name="docIssuingPlace"
            label="Lungo di Rilascio Documento"
            variant="outlined"
            value={queryDocIssuing}
            onChange={handleChange}
            // disabled={form.citizen === ""}
            onBlur={() => {
              const exactMatch = finalFiltered.some(
                (item) => item.country === queryDocIssuing
              );
              if (!exactMatch) {
                setQueryDocIssuing("");
                setForm((prev) => ({ ...prev, docIssuingPlace: "" }));
              }
              setTimeout(() => setOpenDocIssing(false), 200);
            }}
            error={submitClicked && error.docIssuingPlace}
            helperText={
              submitClicked && error.docIssuingPlace
                ? "Lungo di Rilascio Documento is required"
                : ""
            }
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: !form.docIssuingPlace ? "blue" : undefined,
                borderWidth: !form.docIssuingPlace ? "1px" : undefined,
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: !form.docIssuingPlace ? "blue" : undefined,
              },
              "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: !form.placeOfBirth ? "blue" : undefined,
                },
              "& .MuiInputLabel-root": {
                color: !form.docIssuingPlace ? "black" : undefined,
              },
              "& .Mui-disabled": {
                cursor: "not-allowed",
              },
            }}
          />
          {openDocIssing && finalFiltered.length > 0 && (
            <Paper
              sx={{
                position: "absolute",
                width: "100%",
                zIndex: 10,
                maxHeight: 250,
                overflowY: "auto",
              }}
            >
              {finalFiltered.map((item, index) => (
                <MenuItem
                  key={index}
                  onMouseDown={() => {
                    setQueryDocIssuing(item.country);
                    setForm((prev) => ({
                      ...prev,
                      docIssuingPlace: item.code,
                    }));
                    setOpenDocIssing(false);
                  }}
                >
                  {item.country}
                </MenuItem>
              ))}
            </Paper>
          )} */}

          <TextField
            className="textField"
            name="docIssuingPlace"
            label="Lungo di Rilascio Documento"
            variant="outlined"
            value={queryDocIssuing}
            onChange={handleChange}
            onBlur={() => {
              const exactMatch = filteredDocIssuing.some(
                (item) => item.country === queryDocIssuing,
              );
              if (!exactMatch) {
                setQueryDocIssuing("");
                setForm((prev) => ({ ...prev, docIssuingPlace: "" }));
              }
              setTimeout(() => setOpen(false), 200);
            }}
            error={submitClicked && error.docIssuingPlace}
            helperText={
              submitClicked && error.docIssuingPlace
                ? "Luogo di Nascita is required"
                : ""
            }
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: !form.docIssuingPlace ? "blue" : undefined,
                borderWidth: !form.docIssuingPlace ? "1px" : undefined,
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: !form.docIssuingPlace ? "blue" : undefined,
              },
              "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: !form.docIssuingPlace ? "blue" : undefined,
                },
              // "& .MuiInputLabel-root": {
              //   color: !form.citizen ? "blue" : undefined,
              // },
              "& .Mui-disabled": {
                cursor: "not-allowed",
              },
            }}
          />

          {openDocIssing && filteredDocIssuing.length > 0 && (
            <Paper
              sx={{
                position: "absolute",
                width: "100%",
                zIndex: 10,
                maxHeight: 250,
                overflowY: "auto",
              }}
            >
              {filteredDocIssuing.map((item, index) => (
                <MenuItem
                  key={index}
                  onMouseDown={() => {
                    setQueryDocIssuing(item.country);
                    setForm((prev) => ({
                      ...prev,
                      docIssuingPlace: item.code,
                    }));
                    setOpenDocIssing(false);
                  }}
                >
                  {item.country}
                </MenuItem>
              ))}
            </Paper>
          )}

          <div className="doc-type-line">
            <TextField
              className="textField"
              name="docType"
              variant="outlined"
              label="Tipo Documento"
              value={queryDocType}
              onChange={handleChangeDocType}
              onBlur={() => {
                const exactMatch = filteredDoc.some(
                  (item) => item.name === queryDocType,
                );
                if (!exactMatch) {
                  setQueryDocType("");
                  setForm((prev) => ({ ...prev, docType: "" }));
                }
                setTimeout(() => setOpenDoc(false), 200);
              }}
              error={submitClicked && error.docType}
              helperText={
                submitClicked && error.docType
                  ? "Tipo Documento is required"
                  : ""
              }
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: !queryDocType ? "blue" : undefined,
                  borderWidth: !queryDocType ? "1px" : undefined,
                },

                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: !queryDocType ? "blue" : undefined,
                },

                "& .MuiInputLabel-root": {
                  color: !queryDocType ? "black" : undefined,
                },
              }}
            />

            {openDoc && filteredDoc.length > 0 && (
              <Paper
                sx={{
                  position: "absolute",
                  width: "50%",
                  zIndex: 10,
                  maxHeight: 250,
                  overflowY: "auto",
                }}
              >
                {filteredDoc.map((item, index) => (
                  <MenuItem
                    key={index}
                    onMouseDown={() => {
                      setQueryDocType(item.name);
                      setForm((prev) => ({
                        ...prev,
                        docType: item.ID,
                      }));
                      setOpenDoc(false);
                    }}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Paper>
            )}

            <TextField
              className="textField"
              id="outlined-basic"
              label="Numero Documento"
              variant="outlined"
              name="docNumber"
              value={form.docNumber}
              onChange={handleChange}
              error={submitClicked && error.docNumber}
              helperText={
                submitClicked && error.docNumber ? "Numero Documento" : ""
              }
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: !form.docNumber ? "blue" : undefined,
                  borderWidth: !form.docNumber ? "1px" : undefined,
                },

                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: !form.docNumber ? "blue" : undefined,
                },

                "& .MuiInputLabel-root": {
                  color: !form.docNumber ? "black" : undefined,
                },
              }}
            />
          </div>
        </div>

        <div className="btn-line">
          <button
            className="confirm"
            style={{ fontFamily: "Roboto" }}
            onClick={handleSubmit}
          >
            {btnName}
          </button>
          <button
            className="cancel"
            style={{ fontFamily: "Roboto" }}
            onClick={() => {
              navigate("/adminuser/views");
            }}
          >
            Annulla
          </button>
        </div>
      </div>
    </div>
  );
};

export default WPDashboard;
